import { vrfAbi } from '@/abi'
import { useContractAddresses } from '@/hooks'
import { formatEther } from 'viem'
import { useAccount, useReadContract } from 'wagmi'

export const useGetSubscription = (subId) => {
  const contracts = useContractAddresses()
  const { address } = useAccount()

  const isValidSubId = address && Number(subId) > 0

  const { data, isLoading, refetch } = useReadContract({
    abi: vrfAbi,
    address: contracts.vrf,
    functionName: 'getSubscription',
    args: [subId],
    enabled: isValidSubId,
  })

  const [balance = 0, reqCount, owner, consumers] = data || []

  const formattedConsumers = consumers?.map((consumer) => ({
    address: consumer,
    lastFullfillment: 0,
    totalSpent: 0,
  }))

  const subscription = {
    balance: Number(balance),
    formattedBalance: formatEther(balance),
    reqCount: Number(reqCount),
    owner,
    consumers: formattedConsumers,
    consumersCount: consumers?.length,
    subId,
  }

  const isMySubscription = owner === address

  return {
    data: isMySubscription ? subscription : {},
    isLoading: isLoading,
    isOwner: isMySubscription,
    refetch,
  }
}
